import React, { FC } from 'react'

const Spinner: FC = () => {
  return (
    <div className="plaid-assets__loading-container plaid-assets__mb-24">
      <div className="plaid-assets__loading-spinner"></div>
    </div>
  )
}

export default Spinner
